<div class="modal-header"><h2 class="modal-title">Email Invoice</h2></div>
<div class="modal-body" (keyup.esc)="cancel()">
    <dx-form *ngIf="email" [formData]="email" validationGroup="mainValidationGroup">
        <dxi-item itemType="group">
            <!-- <dxi-item itemType="group" [colCount]="2">
                <dxi-item [label]="{ text: 'Addresses' }" *ngIf="email">
                    <div *dxTemplate>
                        <dx-select-box [(value)]="selectedAddress" [items]="emailAddresses" valueExpr="email" displayExpr="email" searchEnabled="true" searchMode="startswith">
                        </dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item>
                    <button type="button" class="btn btn-sm btn-secondary mt-1 mr-4" (click)="addAddress()">Add Address</button>
                </dxi-item>
            </dxi-item> -->

            <dxi-item dataField="to" [label]="{ text: 'To' }">
                <dxi-validation-rule type="required" message="Required"> </dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="subject" [label]="{ text: 'Subject' }"> </dxi-item>
            <dxi-item dataField="includeStrip" [label]="{ text: 'Add Credit Card' }" editorType="dxCheckBox" [editorOptions]="{ onValueChanged: buildEmailBody }" > </dxi-item>

            <dxi-item [label]="{ text: 'Body' }">
                <div *dxTemplate>
                    <dx-text-area [(value)]="email.body" [height]="350"> </dx-text-area>
                </div>
            </dxi-item>
        </dxi-item>
    </dx-form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" [disabled]="processing" (click)="save()">Send</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
</div>
